import React from "react";
import SectionHeader from "@/components/shared/SectionHeader";
import { EISG_IMG } from "@/lib/data";
import { useI18n } from "@/lib/i18n";

const BDAbout = () => {
  const { t } = useI18n();
  const values = [0, 1, 2, 3].map((i) => ({
    num: String(i + 1).padStart(2, "0"),
    title: t(`about.values.${i}.title`),
    desc: t(`about.values.${i}.desc`),
  }));

  return (
    <div>
      <section className="relative py-32 lg:py-40 overflow-hidden bg-[#0A192F] text-white grain">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
          <div className="overline text-[#D4AF37] mb-6">{t("about.hero.eyebrow")}</div>
          <h1 className="font-bd text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] max-w-4xl">
            {t("about.hero.title")}
          </h1>
          <p className="mt-8 text-lg sm:text-xl text-white/75 max-w-3xl leading-relaxed">
            {t("about.hero.body")}
          </p>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5">
            <SectionHeader number={t("about.thesis.number")} eyebrow={t("about.thesis.eyebrow")} title={t("about.thesis.title")} />
          </div>
          <div className="lg:col-span-7 text-[#0A192F]/80 text-lg leading-relaxed space-y-5">
            <p>{t("about.thesis.p1")}</p>
            <p>{t("about.thesis.p2")}</p>
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-[#FAFAFA]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <SectionHeader number={t("about.values.number")} eyebrow={t("about.values.eyebrow")} title={t("about.values.title")} />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#0A192F]/10">
            {values.map((v) => (
              <div key={v.num} className="bg-white p-10 lift-card">
                <div className="section-num">— {v.num}</div>
                <h3 className="font-bd text-2xl mt-4 text-[#0A192F]">{v.title}</h3>
                <p className="mt-3 text-[#0A192F]/70 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <img src={EISG_IMG.boardroom} alt="Leadership" className="w-full h-[520px] object-cover" />
          </div>
          <div className="lg:col-span-6">
            <div className="overline text-[#0A192F]/60 mb-4">{t("about.footprint.number")}</div>
            <h2 className="font-bd text-3xl sm:text-4xl lg:text-5xl text-[#0A192F] tracking-tight leading-[1.02] font-bold">
              {t("about.footprint.title")} <span className="text-[#F58220]">{t("about.footprint.accent")}</span>
            </h2>
            <p className="mt-6 text-[#0A192F]/75 leading-relaxed text-lg">
              {t("about.footprint.body")}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BDAbout;
